import React, { FC } from 'react';
import { mergeCrossSellWithUpsell } from '@utils/helpers';
import Cookie from 'js-cookie';
import { useTranslations } from '@lang';
import {
  SpaEntityContainer,
  SpaEntityContainerProps,
  parseSpaEntityData,
} from '@common/components/SpaEntity/SpaEntityContainer';
import { TreatmentConfigWizardContainer } from '../SpaTreatmentConfigWizard/SpaTreatmentConfigWizardContainer';
import { PageContext, RoutingData } from '@common/components/PageContext';
import { Routes } from '@common/constants';
import { useLabels } from '@features/Menu/useLabels';
import { useGetSpaSettings, useGetSpaTreatment } from '@features/spa/hooks';
import { Spinner } from '@common/components';
import { parseDateToString } from '@utils/helpers';

export const SpaTreatmentContainer: FC<SpaEntityContainerProps> = ({
  id,
  bookingStep,
  property,
  language,
  basketGuests,
  basketDetails,
  updateBasket,
  createBasket,
  signIn,
  destroy,
  upSellName,
  defaultTitle,
  entityType,
  journeyParams,
}) => {
  const { t } = useTranslations();
  const labels = useLabels();
  const parentPageName = t('spa.spaTreatment');
  const { data: spaEntity, isFetching } = useGetSpaTreatment(
    property.id,
    language,
    id,
    parseDateToString(journeyParams.spaDate)
  );
  const { data: spaSettings } = useGetSpaSettings(property.id);
  const { termsAndConditions = '' } = spaSettings || {};
  const routingData: RoutingData = {
    message: t('common.backToModuleRoot', {
      entity: labels?.treatments || t('app.spaTreatments'),
    }),
    href: Routes.SPA_TREATMENT_LIST,
  };

  const mergedItems = mergeCrossSellWithUpsell(
    spaEntity?.upSell,
    upSellName,
    spaEntity?.crossSellObjects
  );

  const handleBasketUpdate = (data) => {
    if (spaEntity) {
      const parsedEntity = parseSpaEntityData(data, spaEntity, entityType);

      const basketId = Cookie.get('basketId');

      if (basketId) {
        return updateBasket(property.id, basketId, language, {
          items: [...basketDetails.items, parsedEntity],
        });
      }
      return createBasket(property.id, language, {
        items: [parsedEntity],
      });
    }
  };

  if (!spaEntity) {
    return <Spinner showDelayMessage isActive={isFetching} />;
  }

  return (
    <PageContext value={{ parentPageName, routingData }}>
      <SpaEntityContainer
        spaEntity={spaEntity}
        spaTermsAndConditions={termsAndConditions}
        bookingStep={bookingStep}
        property={property}
        language={language}
        basketGuests={basketGuests}
        basketDetails={basketDetails}
        signIn={signIn}
        destroy={destroy}
        defaultTitle={defaultTitle}
        SpaEntityConfigurationWizard={TreatmentConfigWizardContainer}
        mergedItems={mergedItems}
        handleBasketUpdate={handleBasketUpdate}
      />
    </PageContext>
  );
};
